<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import {
        getUsersList,
        getMembersList,
        createUser,
        saveUser,
        deleteUser
    } from "../api.svelte";

    import {ERROR_DISAPPEAR_AFTER, errorReasons, USER_STATUS_TEXT} from "../../utils/general";

    import {getContext, onMount} from "svelte";

    import dayjs from "dayjs";
    import { Dropdown } from "carbon-components-svelte";
    import {checkUnauthorized} from "../../utils/session";

    import { fade } from 'svelte/transition';

    const router = getContext('router');

    const USER_LEVEL_TEXT = {
        'business': 'Gewerbe',
        'admin': 'Admin'
    };

    const USER_ROLE_TEXT = {
        'management': 'Management',
        'sales': 'Verkauf',
        'none': ''
    };

    let currentOverlay = 'none';
    let currentUserId = false;
    let currentUser = false;

    let memberList = false;
    let userList = false;
    let listSearchQuery = '';

    let userCreateLoading = false;
    let userFullname = '';
    let userEmail = '';
    let userPassword = '';
    let userMemberId = 'none';
    $: userLevel = (userMemberId === 'none') ? 'admin' : 'business';
    let userRole = 'none';

    // TODO: Fix this ye
    let userStatus = 'pending';

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;

    $: inSearchQuery = (user) => {

        if (listSearchQuery === '') {

            return true;
        }

        const searchQuery = listSearchQuery.toLowerCase();

        return user['email'].toLowerCase().includes(searchQuery)
            || user['fullname'].toLowerCase().includes(searchQuery)
            || user['member'].toLowerCase().includes(searchQuery)
            || USER_LEVEL_TEXT[user['level']].toLowerCase().includes(searchQuery)
            || USER_ROLE_TEXT[user['role']].toLowerCase().includes(searchQuery);

    };

    $: getMembersChoices = () => {

        let tempMemberList = [];

        if (!memberList) return tempMemberList

        for (const [_, member] of Object.entries(memberList)) {

            tempMemberList.push({
                id: member['id'],
                text: member['company']['name']
            });

        }

        return tempMemberList;

    };

    $: getUserRoles = () => {

        if (userMemberId === 'none') {

            userRole = 'none';

            return [];

        }

        userRole = 'sales';

        return [
            {id: 'management', text: 'Management'},
            {id: 'sales', text: 'Verkauf'}
        ];

    };

    $: getMemberName = (memberId) => {

        if (!memberList) return '';

        for (const [_, member] of Object.entries(memberList)) {

            if (member['id'] === memberId) {

                return member['company']['name'];
            }
        }

        return '';

    };

    $: getPageTitle = () => {

        return (currentUserId !== false) ? currentUser['fullname'] : 'Benutzer';
    };


    onMount(() => {

        handleGetUsers();

    });


    let handleGetUsers = () => {

        getUsersList().then((listResult) => {

            if (listResult['status'] !== 'success') {

                checkUnauthorized(router, listResult);
                console.log(listResult);
                return;

            }

            userList = listResult['users'];
            console.log(userList);

            handleGetMembers();

        });

    };

    let handleGetMembers = () => {

        getMembersList().then((listResult) => {

            if (listResult['status'] !== 'success') {

                checkUnauthorized(router, listResult);
                console.log(listResult);
                return;

            }

            console.log(listResult);

            memberList = listResult['members'];

            assignUsersMembers();

        });

    };

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let assignUsersMembers = () => {

        for (const [_, member] of Object.entries(memberList)) {

            for (const [__, user] of Object.entries(userList)) {

                if (user['member'] !== '' || user['level'] === 'admin') {

                    continue;
                }

                if (user['memberid'] === member['id']) {

                    user['member'] = member['company']['name'];
                }

            }

        }

    };

    let handleCreateUser = () => {

        if (userCreateLoading) return;

        if (userFullname === '' || userEmail === '' || userPassword === '') {

            formError = 'fill_fields';
            startErrorResetTimer();
            return;

        }

        if (userPassword.length < 6) {

            formError = 'password_length';
            startErrorResetTimer();

            return;

        }

        if (userMemberId === 'none' && userLevel !== 'admin') {

            // TODO: Set member errore
            return;

        }

        userCreateLoading = true;

        userEmail = userEmail.replaceAll(' ', '').toLowerCase();

        createUser(userEmail, userFullname, userPassword, userMemberId, userLevel, userRole).then((createResult) => {

            userCreateLoading = false;

            if (createResult['status'] !== 'success') {

                checkUnauthorized(router, createResult);
                console.log(createResult);

                formError = createResult['reason'];
                startErrorResetTimer();

                return;

            }

            handleGetUsers();
            currentOverlay = 'none';

        });

    };

    let handleOpenUser = (userId, status) => {

        currentUserId = userId;
        userStatus = status;

        for (const [_, user] of Object.entries(userList)) {

            if (user['id'] === userId) {

                currentUser = user;
                break;

            }

        }

        currentOverlay = 'user';

    };

    let handleSaveUser = () => {

        saveUser(currentUserId, userStatus).then((saveResult) => {

            if (saveResult['status'] !== 'success') {

                checkUnauthorized(router, saveResult);
                console.log(saveResult);
                return;

            }

            handleGetUsers();
            currentOverlay = 'none';

        });

    };

    let handleDeleteUser = () => {

        deleteUser(currentUserId).then((deleteResult) => {

            if (deleteResult['status'] !== 'success') {

                checkUnauthorized(router, deleteResult);
                console.log(deleteResult);
                return;

            }

            handleGetUsers();
            currentOverlay = 'none';

        });
    };

</script>


<div id="users-container">

    <div id="header">

        <h1>{getPageTitle()}</h1>

        {#if currentOverlay === 'none'}

            <button
                    id="user-create"
                    on:click={() => currentOverlay = 'create'}
                    class="btn entity-add">

                <span>Benutzer hinzufügen</span>

            </button>

        {/if}

    </div>

    {#if currentOverlay === 'none'}

        <div id="users-list">

            <div id="list-search-container">

                <input
                        bind:value={listSearchQuery}
                        id="list-search"
                        placeholder="Suchen ..." />

                {#if listSearchQuery !== ''}

                    <img
                            on:click={() => listSearchQuery = ''}
                            src="images/icons/close.svg" alt="Reset" />

                {/if}

            </div>

            <table>

                <tr class="header-row">

                    <th id="list-email">E-Mail</th>
                    <th id="list-fullname">Name</th>
                    <th id="list-status">Status</th>
                    <th id="list-member">Mitglied</th>
                    <th id="list-level">Level</th>
                    <th id="list-role">Role</th>
                    <th id="list-lastseen">Zuletzt gesehen</th>

                </tr>

                {#if userList && memberList}

                    {#each userList as user}

                        {#if inSearchQuery(user)}

                            <tr on:click={() => handleOpenUser(user['id'], user['status'])}>

                                <td>{user['email']}</td>
                                <td>{user['fullname']}</td>
                                <td>{USER_STATUS_TEXT[user['status']]}</td>
                                <td>{user['member']}</td>
                                <td>{USER_LEVEL_TEXT[user['level']]}</td>
                                <td>{USER_ROLE_TEXT[user['role']]}</td>
                                <td>{dayjs.unix(user['lastseen']).format('DD.MM.YY')}</td>

                            </tr>

                        {/if}

                    {/each}

                {/if}

            </table>

        </div>

    {/if}

</div>

{#if currentOverlay === 'user'}

    <div
            id="assistant-user"
            class="assistant">

        <div class="assistant-container details-container">

            <div class="section-title">Status</div>

            <Dropdown
                    bind:selectedId={userStatus}
                    class="dropdown-select"
                    items={[
                        {id: 'pending', text: USER_STATUS_TEXT['pending']},
                        {id: 'active', text: USER_STATUS_TEXT['active']},
                        {id: 'inactive', text: USER_STATUS_TEXT['inactive']},
                        {id: 'blocked', text: USER_STATUS_TEXT['blocked']},
                    ]} />

        </div>

        <div id="user-meta">

            <div id="user-actions" class="details-container actions-panel">

                <button on:click={() => currentOverlay = 'none'} class="btn entity-back">Zurück</button>
                <button on:click={() => handleSaveUser()} class="btn entity-save">Speichern</button>
                <button on:click={() => handleDeleteUser()} class="btn entity-delete">Löschen</button>
                <button on:click={() => currentOverlay = 'none'} class="btn entity-cancel">Abbrechen</button>

            </div>

        </div>

    </div>

{/if}

{#if currentOverlay === 'create'}

    <div
            id="assistant-create"
            class="assistant"
            on:click|self={() => currentOverlay = 'none'}>

        <div class="assistant-container">

            <div
                    on:click={() => currentOverlay = 'none'}
                    class="assistant-close">

                <img src="images/icons/close.svg" alt="Close" />

            </div>

            <div class="section-title">E-Mail-Adresse</div>

            <input
                    bind:value={userEmail}
                    type="email"
                    placeholder="E-Mail-Adresse" />

            <div class="section-title">Vorname Nachname</div>

            <input
                    bind:value={userFullname}
                    type="text"
                    placeholder="Vorname Nachname" />

            <div class="section-title">Passwort (min. 6 Zeichen)</div>

            <input
                    bind:value={userPassword}
                    type="password"
                    placeholder="Passwort" />

            <div class="section-title">Gehört zu Mitglied</div>

            {#if memberList}

                <Dropdown
                        bind:selectedId={userMemberId}
                        class="dropdown-select"
                        items={[
                            {id: 'none', text: 'Keine Auswahl'},
                            ...getMembersChoices()
                        ]} />

            {/if}

            <div class="section-title">Benutzer Level</div>

            <Dropdown
                    bind:selectedId={userLevel}
                    class="dropdown-select"
                    items={[
                        {id: 'admin', text: 'Admin'},
                        {id: 'business', text: 'Mitglied'}
                    ]} />

            <div class="section-title">Benutzer Rolle</div>

            <Dropdown
                    bind:selectedId={userRole}
                    class="dropdown-select"
                    items={[
                        {id: 'none', text: 'Keine Auswahl'},
                        ...getUserRoles()
                    ]} />

            <button
                    on:click={() => handleCreateUser()}
                    class="{(userCreateLoading) ? 'loading btn' : 'btn'}">

                <span>Hinzufügen</span>
                <img src="images/loader/button-loader.svg" />

            </button>

            {#if formError}

                <div transition:fade id="error">

                    {errorReasons[formError]}
                </div>
            {/if}

        </div>

    </div>

{/if}


<style>

    #users-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: calc(100vw - 40vh);
        padding-top: 4vh;
    }

    #users-list {
        position: relative;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        width: fit-content;
        min-height: 50vh;
        padding: 4vh;
        margin-top: 12vh;
        border-radius: 1.5vh;
        font-family: 'Urbanist', sans-serif;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
    }

    #list-search-container {
        position: absolute;
        top: 3vh;
        right: 3vh;
    }

    #list-search {
        width: 26vh;
        height: 3vh;
        padding: 0.75vh 1.5vh;
        font-size: 1.5vh;
    }

    #list-search-container img {
        position: absolute;
        top: 0.75vh;
        right: 1.5vh;
        width: 1.25vh;
        height: 1.25vh;
        cursor: pointer;
    }

    table {
        margin-top: 6vh;
        border-spacing: 0;
    }

    table tr {
        transition: all 0.2s ease;
    }

    table tr:not(.header-row):hover {
        cursor: pointer;
        background-color: rgba(123, 194, 255, 0.075);
    }

    table th, table td {
        padding: 0.75vh;
        font-size: 1.5vh;
    }

    table th {
        font-weight: 500;
        text-align: left;
    }

    th#list-email {
        width: 16vh;
    }

    th#list-fullname {
        width: 16vh;
    }

    th#list-status {
        width: 7vh;
    }

    th#list-member {
        width: 16vh;
    }

    th#list-level {
        width: 16vh;
    }

    th#list-role {
        width: 16vh;
    }

    th#list-lastseen {
        width: 16vh;
    }

    #assistant-user {
        flex-direction: row;
    }

    #assistant-user > .assistant-container.details-container {
        margin-bottom: 0;
    }

    #user-meta {
        margin-left: 4vh;
    }

    .assistant {
        width: calc(100vw - 28vh);
        height: 100vh;
    }

    .section-title {
        width: 28vh;
        margin-bottom: 1vh;
        font-weight: 500;
        font-size: 1.75vh;
    }

    #error {
        margin-top: 1vh;
        color: red;
    }

    .assistant-container input,
    .assistant-container button,
    .assistant-container :global(.dropdown-select button),
    .assistant-container :global(.bx--list-box__menu) {
        width: 28vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

</style>

